/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * Api Url in the Farelanes staging layer.
 */

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://staging-api.myfarelanes.com/api/';
